import React from 'react';

const ScreenContainer = (props) => {
  return (
    <div className="container-fluid">
      {props.children}
    </div>
  );
};

export default ScreenContainer;
